// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2wUMT","footer":"ChangeClinic_footer__3TbQ9"};